export const translations = {
  de: {
    // Nav
    "nav.home": "Startseite",
    "nav.about": "Über Uns",
    "nav.services": "Leistungen",
    "nav.projects": "Referenzen",
    "nav.planner": "Hallenplaner",
    "nav.blog": "News",
    "nav.contact": "Kontakt",
    "nav.cta": "Kontakt",
    // Hero
    "hero.title": "Ihr Partner für internationalen Leichtmetallhallenbau",
    "hero.subtitle": "Planung, Lieferung und Montage aus einer Hand. Als Generalunternehmer realisieren wir Projekte in Deutschland, Europa und weltweit – zuverlässig, termingerecht und in bewährter deutscher Qualität.",
    "hero.cta1": "Halle konfigurieren",
    "hero.cta2": "Kontakt aufnehmen",
    // Stats
    "stats.projects": "Projekte realisiert",
    "stats.years": "Jahre Erfahrung",
    "stats.countries": "Länder",
    "stats.sqm": "m² realisiert",
    // Services
    "services.tag": "Unsere Leistungen",
    "services.title": "Alles aus einer Hand",
    "services.subtitle": "Von der Planung bis zur schlüsselfertigen Übergabe – ITCS ist Ihr internationaler Partner für Leichtmetallhallenbau und industrielle Expansion.",
    "services.more": "Mehr erfahren",
    "servicesPage.title": "Leistungen rund um Ihre Leichtbauhalle",
    "servicesPage.subtitle": "Projektsteuerung, Hallenmontage, Service & Wartung und Sockelabdichtung – alles aus einer Hand, national und international.",
    "nav.allServices": "Alle Leistungen",
    "hero.imageAlt": "Leichtbauhalle mit Industrietoren – realisiert von ITCS Industrial",
    "about.imageAlt": "Montageteam von ITCS Industrial beim Aufbau einer Leichtbauhalle",
    "service.overview": "Unsere Leistungen im Überblick",
    "service.overviewText": "Alles, was Sie von uns erwarten können – sauber abgestimmt, termingerecht umgesetzt und vollständig dokumentiert.",
    "service.process": "So läuft es ab",
    "service.faq": "Häufige Fragen",
    "service.related": "Weitere Leistungen",
    "service.ctaTitle": "Sprechen Sie mit uns über Ihr Projekt",
    "service.ctaText": "Ein Ansprechpartner, klare Aussagen, schnelle Rückmeldung – wir beraten Sie unverbindlich.",
    "service.ctaBtn": "Unverbindlich anfragen",
    "notfound.title": "Seite nicht gefunden",
    "notfound.text": "Die aufgerufene Seite existiert nicht oder wurde verschoben. Hier geht es weiter:",
    "notfound.home": "Zur Startseite",
    "form.error": "Senden fehlgeschlagen – bitte später erneut versuchen.",
    "form.invalid": "Bitte prüfen Sie Ihre Eingaben (z. B. E-Mail-Adresse).",
    "form.rateLimited": "Zu viele Anfragen – bitte versuchen Sie es später erneut.",
    // About
    "about.tag": "Über ITCS",
    "about.title": "Engineering. Qualität. Weltweit.",
    "about.heroSubtitle": "ITCS Industrial Trade & Construction Systems GmbH – Ihr internationaler Partner für Leichtmetallhallenbau, Global Sourcing und Markterschließung.",
    "about.text1": "Was einst als Nebentätigkeit neben dem Studium begann, ist heute ein stetig wachsendes Unternehmen. ITCS Industrial Trade & Construction Systems GmbH steht für moderne Lösungen im industriellen Hallenbau und vereint Engineering-Kompetenz mit internationaler Erfahrung.",
    "about.text2": "Als Generalunternehmer und internationaler Partner realisieren wir Leichtmetallhallen weltweit. Mit einem Team aus Wirtschaftsingenieuren kümmern wir uns um globales Sourcing, internationale Markterschließung und die komplette Projektabwicklung aus einer Hand.",
    "about.value1.title": "Engineering Know-how",
    "about.value1.text": "Deutsche Ingenieurskunst und technische Präzision in jedem Projekt.",
    "about.value2.title": "Internationale Präsenz",
    "about.value2.text": "Projekte in der EU, Südamerika und Indien – global denken, lokal handeln.",
    "about.value3.title": "Alles aus einer Hand",
    "about.value3.text": "Planung, Lieferung, Montage und Projektsteuerung – ein Ansprechpartner.",
    "about.cta": "Mehr über uns",
    // Trust / Partners
    "trust.title": "Unsere Partner",
    // CTA
    "cta.title": "Bereit für Ihr nächstes Projekt?",
    "cta.subtitle": "Konfigurieren Sie Ihre Halle in wenigen Schritten oder kontaktieren Sie uns direkt für eine individuelle Beratung.",
    "cta.btn1": "Halle planen",
    "cta.btn2": "Kontakt aufnehmen",
    // FAQ
    "faq.tag": "Häufig gestellte Fragen",
    "faq.title": "Antworten auf Ihre Fragen",
    // Footer
    "footer.description": "ITCS Industrial Trade & Construction Systems GmbH – Ihr Partner für Leichtbauhallen: Projektsteuerung, Hallenmontage, Service & Wartung und Sockelabdichtung. National und international, mit deutscher Qualität.",
    "footer.services": "Leistungen",
    "footer.company": "Unternehmen",
    "footer.legal": "Rechtliches",
    "footer.impressum": "Impressum",
    "footer.datenschutz": "Datenschutz",
    "footer.rights": "Alle Rechte vorbehalten.",
    "footer.regions": "Einsatzgebiete",
    "google.tag": "Standort Dresden",
    "google.title": "So finden Sie uns",
    "google.text": "Unser Sitz ist in Dresden – von hier aus betreuen wir Hallenprojekte in ganz Mitteldeutschland, bundesweit und international.",
    "google.profile": "Google-Profil ansehen",
    "google.maps": "In Google Maps öffnen",
    "google.directions": "Route planen",
    "google.review": "Auf Google bewerten",
    "map.consent": "Beim Laden der Karte werden Daten (z. B. Ihre IP-Adresse) an Google übertragen.",
    "map.load": "Karte laden",
    "map.privacy": "Datenschutz",
    // Contact
    "contact.tag": "Kontakt",
    "contact.title": "Sprechen Sie mit uns",
    "contact.subtitle": "Wir freuen uns auf Ihre Anfrage. Ob Projektanfrage oder allgemeine Fragen – wir sind für Sie da.",
    "contact.name": "Name",
    "contact.email": "E-Mail",
    "contact.phone": "Telefon",
    "contact.company": "Unternehmen",
    "contact.message": "Nachricht",
    "contact.language": "Bevorzugte Kontaktsprache",
    "contact.language.de": "Deutsch",
    "contact.language.en": "Englisch",
    "contact.language.es": "Spanisch",
    "contact.send": "Nachricht senden",
    "contact.success": "Nachricht erfolgreich gesendet!",
    "contact.address": "Adresse",
    "contact.addressVal": "Dresden, Deutschland",
    "contact.emailVal": "info@itcs-global.com",
    "contact.phoneVal": "+49 172 8116925",
    // Hall Planner
    "planner.tag": "Hallenplaner",
    "planner.title": "Konfigurieren Sie Ihre Halle",
    "planner.subtitle": "In wenigen Schritten zu Ihrem individuellen Angebot. Wählen Sie Ihre Anforderungen und erhalten Sie eine unverbindliche Beratung.",
    "planner.step1": "Abmessungen",
    "planner.step2": "Nutzung",
    "planner.step3": "Ausstattung",
    "planner.step4": "Kontaktdaten",
    "planner.length": "Länge (m)",
    "planner.width": "Breite (m)",
    "planner.height": "Höhe (m)",
    "planner.area": "Fläche",
    "planner.usage": "Nutzungsart",
    "planner.usage.warehouse": "Lager / Logistik",
    "planner.usage.production": "Produktion / Werkstatt",
    "planner.usage.commercial": "Gewerbe / Handel",
    "planner.usage.agriculture": "Landwirtschaft",
    "planner.usage.sports": "Sport / Freizeit",
    "planner.usage.other": "Sonstiges",
    "planner.features": "Ausstattungsmerkmale",
    "planner.feat.insulation": "Wärmedämmung",
    "planner.feat.doors": "Industrietore",
    "planner.feat.windows": "Fenster / Lichtbänder",
    "planner.feat.hvac": "Lüftung, Klima & Heizung",
    "planner.feat.fire": "Brandschutz",
    "planner.feat.floor": "Fußboden",
    "planner.feat.office": "Büroanbau",
    "planner.feat.slope": "Gefälle des Untergrunds",
    "planner.notes": "Weitere Anmerkungen",
    "planner.next": "Weiter",
    "planner.back": "Zurück",
    "planner.submit": "Anfrage senden",
    "planner.success": "Ihre Anfrage wurde erfolgreich gesendet! Wir melden uns in Kürze bei Ihnen.",
    // Projects
    "projects.tag": "Referenzen",
    "projects.title": "Unsere Projekte",
    "projects.subtitle": "Überzeugen Sie sich von unserer Arbeit. Ausgewählte Referenzprojekte aus verschiedenen Bereichen.",
    "projects.all": "Alle",
    "projects.location": "Standort",
    "projects.year": "Jahr",
    // Blog
    "blog.tag": "Neuigkeiten",
    "blog.title": "Aktuelles von ITCS",
    "blog.readmore": "Weiterlesen",
    // Legal
    "legal.impressum.title": "Impressum",
    "legal.datenschutz.title": "Datenschutzerklärung",
  },
  en: {
    "nav.home": "Home",
    "nav.about": "About Us",
    "nav.services": "Services",
    "nav.projects": "References",
    "nav.planner": "Hall Planner",
    "nav.blog": "News",
    "nav.contact": "Contact",
    "nav.cta": "Contact",
    "hero.title": "Your International Partner for Light Metal Hall Construction",
    "hero.subtitle": "Planning, delivery and assembly from a single source. As a general contractor, we realize projects in Germany, Europe and worldwide – reliably, on schedule and with proven German quality.",
    "hero.cta1": "Configure Hall",
    "hero.cta2": "Contact Us",
    "stats.projects": "Projects Realized",
    "stats.years": "Years Experience",
    "stats.countries": "Countries",
    "stats.sqm": "m² Realized",
    "services.tag": "Our Services",
    "services.title": "Everything from One Source",
    "services.subtitle": "From planning to final handover – ITCS is your international partner for light metal hall construction and industrial expansion.",
    "services.more": "Learn more",
    "servicesPage.title": "Services for Your Lightweight Hall",
    "servicesPage.subtitle": "Project management, hall assembly, service & maintenance and base sealing – all from one source, in Germany and internationally.",
    "nav.allServices": "All services",
    "hero.imageAlt": "Lightweight hall with industrial doors – built by ITCS Industrial",
    "about.imageAlt": "ITCS Industrial assembly team erecting a lightweight hall",
    "service.overview": "Our services at a glance",
    "service.overviewText": "Everything you can expect from us – carefully coordinated, delivered on schedule and fully documented.",
    "service.process": "How it works",
    "service.faq": "Frequently asked questions",
    "service.related": "More services",
    "service.ctaTitle": "Let's talk about your project",
    "service.ctaText": "One contact person, clear answers, a quick response – we advise you without obligation.",
    "service.ctaBtn": "Send a non-binding inquiry",
    "notfound.title": "Page not found",
    "notfound.text": "The page you requested does not exist or has been moved. Continue here:",
    "notfound.home": "Back to home",
    "form.error": "Sending failed – please try again later.",
    "form.invalid": "Please check your entries (e.g. e-mail address).",
    "form.rateLimited": "Too many requests – please try again later.",
    "about.tag": "About ITCS",
    "about.title": "Engineering. Quality. Worldwide.",
    "about.heroSubtitle": "ITCS Industrial Trade & Construction Systems GmbH – Your international partner for light metal hall construction, global sourcing and market development.",
    "about.text1": "What once started as a side activity alongside university studies has grown into a steadily expanding company. ITCS Industrial Trade & Construction Systems GmbH stands for modern solutions in industrial hall construction, combining engineering competence with international experience.",
    "about.text2": "As a general contractor and international partner, we realize lightweight metal halls worldwide. With a team of industrial engineers, we take care of global sourcing, international market development and complete project execution from a single source.",
    "about.value1.title": "Engineering Know-how",
    "about.value1.text": "German engineering expertise and technical precision in every project.",
    "about.value2.title": "International Presence",
    "about.value2.text": "Projects in the EU, South America and India – think globally, act locally.",
    "about.value3.title": "All-in-One Service",
    "about.value3.text": "Planning, delivery, assembly and project management – one point of contact.",
    "about.cta": "Learn more about us",
    "trust.title": "Our Partners",
    "cta.title": "Ready for Your Next Project?",
    "cta.subtitle": "Configure your hall in a few steps or contact us directly for individual consultation.",
    "cta.btn1": "Plan Your Hall",
    "cta.btn2": "Contact Us",
    "faq.tag": "Frequently Asked Questions",
    "faq.title": "Answers to Your Questions",
    "footer.description": "ITCS Industrial Trade & Construction Systems GmbH – your partner for lightweight halls: project management, hall assembly, service & maintenance and base sealing. In Germany and internationally, with German quality.",
    "footer.services": "Services",
    "footer.company": "Company",
    "footer.legal": "Legal",
    "footer.impressum": "Legal Notice",
    "footer.datenschutz": "Privacy Policy",
    "footer.rights": "All rights reserved.",
    "footer.regions": "Service areas",
    "google.tag": "Dresden location",
    "google.title": "How to find us",
    "google.text": "We are based in Dresden – from here we support hall projects across central Germany, nationwide and internationally.",
    "google.profile": "View Google profile",
    "google.maps": "Open in Google Maps",
    "google.directions": "Get directions",
    "google.review": "Review us on Google",
    "map.consent": "Loading the map transfers data (e.g. your IP address) to Google.",
    "map.load": "Load map",
    "map.privacy": "Privacy",
    "contact.tag": "Contact",
    "contact.title": "Talk to Us",
    "contact.subtitle": "We look forward to your inquiry. Whether project request or general questions – we are here for you.",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.phone": "Phone",
    "contact.company": "Company",
    "contact.message": "Message",
    "contact.language": "Preferred Contact Language",
    "contact.language.de": "German",
    "contact.language.en": "English",
    "contact.language.es": "Spanish",
    "contact.send": "Send Message",
    "contact.success": "Message sent successfully!",
    "contact.address": "Address",
    "contact.addressVal": "Dresden, Germany",
    "contact.emailVal": "info@itcs-global.com",
    "contact.phoneVal": "+49 172 8116925",
    "planner.tag": "Hall Planner",
    "planner.title": "Configure Your Hall",
    "planner.subtitle": "Get your individual offer in just a few steps. Select your requirements and receive a non-binding consultation.",
    "planner.step1": "Dimensions",
    "planner.step2": "Usage",
    "planner.step3": "Features",
    "planner.step4": "Contact Info",
    "planner.length": "Length (m)",
    "planner.width": "Width (m)",
    "planner.height": "Height (m)",
    "planner.area": "Area",
    "planner.usage": "Usage Type",
    "planner.usage.warehouse": "Warehouse / Logistics",
    "planner.usage.production": "Production / Workshop",
    "planner.usage.commercial": "Commercial / Trade",
    "planner.usage.agriculture": "Agriculture",
    "planner.usage.sports": "Sports / Recreation",
    "planner.usage.other": "Other",
    "planner.features": "Equipment Features",
    "planner.feat.insulation": "Thermal Insulation",
    "planner.feat.doors": "Industrial Gates",
    "planner.feat.windows": "Windows / Skylights",
    "planner.feat.hvac": "Ventilation, Climate & Heating",
    "planner.feat.fire": "Fire Protection",
    "planner.feat.floor": "Flooring",
    "planner.feat.office": "Office Annex",
    "planner.feat.slope": "Ground Slope / Gradient",
    "planner.notes": "Additional Notes",
    "planner.next": "Next",
    "planner.back": "Back",
    "planner.submit": "Submit Inquiry",
    "planner.success": "Your inquiry has been submitted successfully! We will get back to you shortly.",
    "projects.tag": "References",
    "projects.title": "Our Projects",
    "projects.subtitle": "See our work for yourself. Selected reference projects from various sectors.",
    "projects.all": "All",
    "projects.location": "Location",
    "projects.year": "Year",
    "blog.tag": "News",
    "blog.title": "Latest from ITCS",
    "blog.readmore": "Read more",
    "legal.impressum.title": "Legal Notice",
    "legal.datenschutz.title": "Privacy Policy",
  },
  es: {
    "nav.home": "Inicio",
    "nav.about": "Sobre Nosotros",
    "nav.services": "Servicios",
    "nav.projects": "Referencias",
    "nav.planner": "Planificador",
    "nav.blog": "Noticias",
    "nav.contact": "Contacto",
    "nav.cta": "Contacto",
    "hero.title": "Su Socio Internacional para la Construcción de Naves Metálicas",
    "hero.subtitle": "Planificación, entrega y montaje de una sola fuente. Como contratista general, realizamos proyectos en Alemania, Europa y en todo el mundo, de forma fiable y con calidad alemana probada.",
    "hero.cta1": "Configurar Nave",
    "hero.cta2": "Contáctenos",
    "stats.projects": "Proyectos Realizados",
    "stats.years": "Años de Experiencia",
    "stats.countries": "Países",
    "stats.sqm": "m² Realizados",
    "services.tag": "Nuestros Servicios",
    "services.title": "Todo de Una Sola Fuente",
    "services.subtitle": "Desde la planificación hasta la entrega final – ITCS es su socio internacional para la construcción de naves metálicas y expansión industrial.",
    "services.more": "Más información",
    "servicesPage.title": "Servicios para su Nave Ligera",
    "servicesPage.subtitle": "Gestión de proyectos, montaje de naves, servicio y mantenimiento y sellado de zócalo, todo de una sola fuente, nacional e internacional.",
    "nav.allServices": "Todos los servicios",
    "hero.imageAlt": "Nave ligera con puertas industriales, realizada por ITCS Industrial",
    "about.imageAlt": "Equipo de montaje de ITCS Industrial levantando una nave ligera",
    "service.overview": "Nuestros servicios de un vistazo",
    "service.overviewText": "Todo lo que puede esperar de nosotros: bien coordinado, ejecutado en plazo y completamente documentado.",
    "service.process": "Así funciona",
    "service.faq": "Preguntas frecuentes",
    "service.related": "Más servicios",
    "service.ctaTitle": "Hablemos de su proyecto",
    "service.ctaText": "Una persona de contacto, respuestas claras y respuesta rápida: le asesoramos sin compromiso.",
    "service.ctaBtn": "Solicitar sin compromiso",
    "notfound.title": "Página no encontrada",
    "notfound.text": "La página solicitada no existe o se ha movido. Continúe aquí:",
    "notfound.home": "Ir al inicio",
    "form.error": "Error al enviar: inténtelo de nuevo más tarde.",
    "form.invalid": "Revise sus datos (p. ej., la dirección de correo).",
    "form.rateLimited": "Demasiadas solicitudes: inténtelo de nuevo más tarde.",
    "about.tag": "Sobre ITCS",
    "about.title": "Ingeniería. Calidad. Mundial.",
    "about.heroSubtitle": "ITCS Industrial Trade & Construction Systems GmbH – Su socio internacional para construcción de naves metálicas, sourcing global y desarrollo de mercados.",
    "about.text1": "Lo que comenzó como una actividad secundaria junto a los estudios universitarios se ha convertido en una empresa en constante crecimiento. ITCS Industrial Trade & Construction Systems GmbH representa soluciones modernas en la construcción industrial de naves, combinando competencia en ingeniería con experiencia internacional.",
    "about.text2": "Como contratista general y socio internacional, realizamos naves metálicas ligeras en todo el mundo. Con un equipo de ingenieros industriales, nos ocupamos del sourcing global, el desarrollo de mercados internacionales y la ejecución completa de proyectos de una sola fuente.",
    "about.value1.title": "Know-how de Ingeniería",
    "about.value1.text": "Experiencia en ingeniería alemana y precisión técnica en cada proyecto.",
    "about.value2.title": "Presencia Internacional",
    "about.value2.text": "Proyectos en la UE, Sudamérica e India – pensar globalmente, actuar localmente.",
    "about.value3.title": "Servicio Integral",
    "about.value3.text": "Planificación, entrega, montaje y gestión de proyectos – un solo punto de contacto.",
    "about.cta": "Más sobre nosotros",
    "trust.title": "Nuestros Socios",
    "cta.title": "¿Listo para Su Próximo Proyecto?",
    "cta.subtitle": "Configure su nave en pocos pasos o contáctenos directamente para una consulta individual.",
    "cta.btn1": "Planificar Nave",
    "cta.btn2": "Contáctenos",
    "faq.tag": "Preguntas Frecuentes",
    "faq.title": "Respuestas a Sus Preguntas",
    "footer.description": "ITCS Industrial Trade & Construction Systems GmbH – su socio para naves ligeras: gestión de proyectos, montaje de naves, servicio y mantenimiento y sellado de zócalo. Nacional e internacional, con calidad alemana.",
    "footer.services": "Servicios",
    "footer.company": "Empresa",
    "footer.legal": "Legal",
    "footer.impressum": "Aviso Legal",
    "footer.datenschutz": "Política de Privacidad",
    "footer.rights": "Todos los derechos reservados.",
    "footer.regions": "Zonas de servicio",
    "google.tag": "Sede en Dresde",
    "google.title": "Cómo encontrarnos",
    "google.text": "Nuestra sede está en Dresde: desde aquí atendemos proyectos de naves en el centro de Alemania, en todo el país y a nivel internacional.",
    "google.profile": "Ver perfil de Google",
    "google.maps": "Abrir en Google Maps",
    "google.directions": "Cómo llegar",
    "google.review": "Valórenos en Google",
    "map.consent": "Al cargar el mapa se transmiten datos (p. ej., su dirección IP) a Google.",
    "map.load": "Cargar mapa",
    "map.privacy": "Privacidad",
    "contact.tag": "Contacto",
    "contact.title": "Hable con Nosotros",
    "contact.subtitle": "Esperamos su consulta. Ya sea una solicitud de proyecto o preguntas generales, estamos aquí para usted.",
    "contact.name": "Nombre",
    "contact.email": "Correo Electrónico",
    "contact.phone": "Teléfono",
    "contact.company": "Empresa",
    "contact.message": "Mensaje",
    "contact.language": "Idioma de contacto preferido",
    "contact.language.de": "Alemán",
    "contact.language.en": "Inglés",
    "contact.language.es": "Español",
    "contact.send": "Enviar Mensaje",
    "contact.success": "¡Mensaje enviado con éxito!",
    "contact.address": "Dirección",
    "contact.addressVal": "Dresde, Alemania",
    "contact.emailVal": "info@itcs-global.com",
    "contact.phoneVal": "+49 172 8116925",
    "planner.tag": "Planificador de Naves",
    "planner.title": "Configure Su Nave",
    "planner.subtitle": "Obtenga su presupuesto individual en pocos pasos. Seleccione sus requisitos y reciba una consulta sin compromiso.",
    "planner.step1": "Dimensiones",
    "planner.step2": "Uso",
    "planner.step3": "Equipamiento",
    "planner.step4": "Datos de Contacto",
    "planner.length": "Largo (m)",
    "planner.width": "Ancho (m)",
    "planner.height": "Altura (m)",
    "planner.area": "Superficie",
    "planner.usage": "Tipo de Uso",
    "planner.usage.warehouse": "Almacén / Logística",
    "planner.usage.production": "Producción / Taller",
    "planner.usage.commercial": "Comercial",
    "planner.usage.agriculture": "Agricultura",
    "planner.usage.sports": "Deportes / Ocio",
    "planner.usage.other": "Otro",
    "planner.features": "Características del Equipamiento",
    "planner.feat.insulation": "Aislamiento Térmico",
    "planner.feat.doors": "Portones Industriales",
    "planner.feat.windows": "Ventanas / Claraboyas",
    "planner.feat.hvac": "Ventilación, Clima y Calefacción",
    "planner.feat.fire": "Protección contra Incendios",
    "planner.feat.floor": "Suelo",
    "planner.feat.office": "Anexo de Oficinas",
    "planner.feat.slope": "Pendiente del Terreno",
    "planner.notes": "Notas Adicionales",
    "planner.next": "Siguiente",
    "planner.back": "Atrás",
    "planner.submit": "Enviar Solicitud",
    "planner.success": "¡Su solicitud ha sido enviada con éxito! Nos pondremos en contacto con usted en breve.",
    "projects.tag": "Referencias",
    "projects.title": "Nuestros Proyectos",
    "projects.subtitle": "Vea nuestro trabajo. Proyectos de referencia seleccionados de diversos sectores.",
    "projects.all": "Todos",
    "projects.location": "Ubicación",
    "projects.year": "Año",
    "blog.tag": "Noticias",
    "blog.title": "Lo Último de ITCS",
    "blog.readmore": "Leer más",
    "legal.impressum.title": "Aviso Legal",
    "legal.datenschutz.title": "Política de Privacidad",
  }
};
